// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ToolbarButtonStyles-modules__buttonWrapper___lQXX","button":"ToolbarButtonStyles-modules__button__AkqbC","active":"ToolbarButtonStyles-modules__active__Hbb3u"};